import { useEffect, useRef, useState } from 'react'
import { NoRecords, PageLoader } from '../../lib/loader'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import moment from 'moment';
import { DepositTransaction } from './UserDetailapi';
import { Search, ArrowUp, ArrowDown, Copy, Check, ExternalLink } from 'lucide-react';
import { useDebounce } from '../../hooks/debounce';
import { useParams } from 'react-router-dom';
import { useToast } from '../../hooks/usetoast';
import { copyToClipboard } from '../../lib/copytoClipboard';
import { useModalContext } from '../../contexts/ModalContext';
import BreadcrumbPagination from '../../utils/BreadcrumbPagination';
import { useBreadcrumbPagination } from '../../hooks/useBreadcrumbPagination';


function CardTransaction() {
    const [tempPage, setTempPage] = useState(0);
    const [tempRows, setTempRows] = useState(10);
    const [search, setSearch] = useState("");
    const toast = useToast();
    const { theme } = useModalContext();
    const [double, setDouble] = useState(false);


    const [sortOrder, setSortOrder] = useState("desc")
    const searchText = useDebounce(search);
    const { id } = useParams();
    const { data: getTransactionHistory, isLoading } = DepositTransaction({
        id,
        userId: id,
        type: "card",
        page: searchText ? 0 : tempPage,
        size: tempRows,
        searchText,
        sortField: "createdAt",
        sortOrder: sortOrder
    })

    // BreadCrumb Pagination

    const totalRecords = getTransactionHistory?.data?.count || 0;

    const {
        page,
        rowsPerPage,
        totalPages,
        handleChangePage,
        handleChangeRowsPerPage
    } = useBreadcrumbPagination(totalRecords, tempRows);

    useEffect(() => {
        setTempPage(page);
    }, [page]);

    useEffect(() => {
        setTempRows(rowsPerPage);
    }, [rowsPerPage]);

    const inputRef = useRef(null);

    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.focus();
            const length = inputRef.current.value.length;
            inputRef.current.setSelectionRange(length, length);
        }
    });

    useEffect(() => {
        setTempPage(0);
        if (handleChangePage) {
            handleChangePage(null, 0);
        }
    }, [searchText]);



    const copyTrxAddress = async data => {
        setDouble(data._id)
        await copyToClipboard(data.txnId)
        toast.success("id copied")
        setTimeout(() => {
            setDouble()
        }, 800)
    }


    const renderInternalTransactionHistoryTable = () => (
        getTransactionHistory?.data?.data?.length > 0 ? (
            <>
                <div style={{ minHeight: "60vh" }}>
                    <div className='table-responsive'>
                        <Table sx={{ minWidth: 650 }} aria-label="user history table">
                            <TableHead>
                                <TableRow>
                                    <TableCell className='text-nowrap' align="center">S.NO</TableCell>
                                    <TableCell className='text-nowrap' align="center">Type</TableCell>

                                    <TableCell className='text-nowrap' align="center">Transfer Amount</TableCell>
                                    {/* <TableCell className='text-nowrap' align="center">Address</TableCell> */}
                                    <TableCell className='text-nowrap' align="center">Transaction Hash / ID</TableCell>
                                    <TableCell className='text-nowrap' align="center">Status</TableCell>
                                    <TableCell className='text-nowrap'>Date and Time {sortOrder !== "desc" ? <ArrowUp onClick={() => setSortOrder(' desc')} style={{ cursor: "pointer" }} /> : <ArrowDown onClick={() => setSortOrder('asc')} style={{ cursor: "pointer" }} />}</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {getTransactionHistory?.data?.data?.map((row, i) => (
                                    <TableRow key={row._id || i}>
                                        <TableCell className='text-nowrap' align="center">{page * rowsPerPage + (i + 1)}</TableCell>
                                        <TableCell className='text-nowrap' align="center">{row.type}</TableCell>

                                        <TableCell className="text-nowrap" align="center">
                                            {row?.transferAmount || row?.sentAmount ? (
                                                <span style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: '5px' }}>
                                                    {row.transferAmount || row?.sentAmount}
                                                    {row?.currencyImage && (
                                                        <img
                                                            src={row.currencyImage}
                                                            alt="Currency Icon"
                                                            style={{
                                                                height: '20px',
                                                                width: '20px',
                                                                borderRadius: '50%',
                                                                verticalAlign: 'middle',
                                                                objectFit: 'cover',
                                                            }}
                                                        />
                                                    )}
                                                </span>
                                            ) : (
                                                '-'
                                            )}
                                        </TableCell>
                                        {/* <TableCell align="center">
                                            {formatAddress(row?.address || row?.fromAddress || '-')}
                                            {addressdouble === row._id ? (
                                                <Check
                                                    size={20}
                                                    style={{ marginLeft: '5px', color: theme ? 'white' : 'black' }}
                                                />
                                            ) : (


                                                row?.address &&
                                                <Copy
                                                    onClick={() => copyuseraddress(row)}
                                                    size={20}
                                                    className="ml-5"
                                                    style={{
                                                        cursor: 'pointer',
                                                        marginLeft: '5px',
                                                        color: theme ? 'white' : 'black',
                                                    }}
                                                />
                                            )}
                                        </TableCell> */}
                                        <TableCell align="center">
                                            {row.txnId ? (
                                                <>
                                                    {`${row.txnId.slice(0, 8)}...${row.txnId.slice(-6)}`}
                                                    {/* {row.txnId} */}
                                                    {double === row._id ? (
                                                        <Check size={20} style={{ marginLeft: "5px", color: theme ? "white" : "black" }} />
                                                    ) : (
                                                        <Copy
                                                            onClick={() => copyTrxAddress(row)}
                                                            size={20}
                                                            className="ml-5"
                                                            style={{ cursor: "pointer", marginLeft: "5px", color: theme ? "white" : "black" }}
                                                        />
                                                    )}

                                                </>
                                            )
                                                : row.txnHash ? (
                                                    <>
                                                        {`${row.txnHash.slice(0, 8)}...${row.txnHash.slice(-6)}`}
                                                        {/* {row.txnHash} */}
                                                        {double === row._id ? (
                                                            <Check size={20} style={{ marginLeft: "5px", color: theme ? "white" : "black" }} />
                                                        ) : (
                                                            <Copy
                                                                onClick={() => copyTrxAddress(row)}
                                                                size={20}
                                                                className="ml-5"
                                                                style={{ cursor: "pointer", marginLeft: "5px", color: theme ? "white" : "black" }}
                                                            />
                                                        )}
                                                        {
                                                            row.explorerUrl &&
                                                            <a
                                                                href={row.explorerUrl}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                className="ml-2"
                                                            >
                                                                <ExternalLink style={{ marginLeft: "5px" }} size={20} />
                                                            </a>
                                                        }

                                                    </>
                                                ) : "--"}



                                        </TableCell>

                                        <TableCell className="text-nowrap" align="center">
                                            {(() => {
                                                const status = row.transactionStatus;
                                                const formatted =
                                                    status ? status.charAt(0).toUpperCase() + status.slice(1).toLowerCase() : "";

                                                const isCompleted = status?.toLowerCase() === "completed";

                                                return (
                                                    <span className={isCompleted ? "text-success" : "text-danger"}>
                                                        {formatted}
                                                    </span>
                                                );
                                            })()}
                                        </TableCell>

                                        <TableCell className='text-nowrap'>
                                            {moment(row?.createdAt).format("DD-MM-YYYY | hh:mm A")}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </div>
                </div>
                <BreadcrumbPagination
                    page={page}
                    rowsPerPage={rowsPerPage}
                    totalPages={totalPages}
                    totalRecords={totalRecords}
                    handleChangePage={handleChangePage}
                    handleChangeRowsPerPage={handleChangeRowsPerPage}
                />
            </>
        ) : (
            <NoRecords />
        )
    );


    return (
        <section>
            <div className="ad_pg_bx bg-white p-3">
                <div className='d-flex justify-content-between align-items-center mb-2'>
                    <div className='col-md-4'>
                        <div className="input-group">
                            <span className="input-group-icon">
                                <Search size={20} color='#aaa9a9' />
                            </span>
                            <input
                                type="text"
                                onChange={(e) => setSearch(e.target.value)}
                                className="form-control"
                                placeholder="Search Address"
                            />
                        </div>
                    </div>
                </div>
                {isLoading ?
                    <PageLoader />
                    :
                    renderInternalTransactionHistoryTable()
                }
            </div>
        </section>
    )
}

export default CardTransaction